import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-maintenance',
  templateUrl: './Maintenance.component.html',
  styleUrls: ['./Maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
	
	public  form 	: UntypedFormGroup;
	emailPattern   : string    = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$";

	constructor(private fb : UntypedFormBuilder) { }

	ngOnInit() {
		this.form = this.fb.group({  
  			email : ['', [Validators.required,Validators.pattern(this.emailPattern)]] ,
		});
	}
}
